import ApiCore from './ApiCore';
import {queryParams} from '../helpers';

class WebhooksService extends ApiCore {

  list(params = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('backoffice/webhooks'+queryParams(params)).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  get(uuid) {
    return new Promise((resolve, reject) => {
      this.instance.get('backoffice/webhooks/'+uuid).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  create(params = null) {
    return new Promise((resolve, reject) => {
      this.instance.post('backoffice/webhooks', {
        ...params
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  update(uuid, params = null) {
    return new Promise((resolve, reject) => {
      this.instance.put('backoffice/webhooks/'+uuid, {
        ...params
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  delete(uuid) {
    return new Promise((resolve, reject) => {
      this.instance.delete('backoffice/webhooks/'+uuid).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  rollHMAC(uuid, params = null) {
    return new Promise((resolve, reject) => {
      this.instance.put('backoffice/webhooks/'+uuid+'/rollHmacKey', {
        ...params
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  test(uuid, params = null) {
    return new Promise((resolve, reject) => {
      this.instance.patch('backoffice/webhooks/'+uuid+'/test', {
        ...params
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

	listEvents(params = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('backoffice/webhooks/eventList'+queryParams(params)).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  // adminList(params = null) {
  //   return new Promise((resolve, reject) => {
  //     this.instance.get('backoffice/admin/webhooks'+queryParams(params)).then(response => {
  //       resolve(response.data);
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // }

  // adminGet(uuid) {
  //   return new Promise((resolve, reject) => {
  //     this.instance.get('backoffice/admin/webhooks/'+uuid).then(response => {
  //       resolve(response.data);
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // }

  // adminCreate(params = null) {
  //   return new Promise((resolve, reject) => {
  //     this.instance.post('backoffice/admin/webhooks'+queryParams(params), {
  //       ...params
  //     }).then(response => {
  //       resolve(response.data);
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // }

  // adminUpdate(uuid, params = null) {
  //   return new Promise((resolve, reject) => {
  //     this.instance.put('backoffice/admin/webhooks/'+uuid, {
  //       ...params
  //     }).then(response => {
  //       resolve(response.data);
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // }

  // adminDelete(uuid) {
  //   return new Promise((resolve, reject) => {
  //     this.instance.delete('backoffice/admin/webhooks/'+uuid).then(response => {
  //       resolve(response.data);
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // }
  
}
let service =  new WebhooksService();
export default service;
